var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('router-view',{class:{ 'filter blur-sm brightness-75': _vm.$store.state.isMenuOpened }}),_c('app-footer'),_c('the-social-media-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }